// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Container } from './style';
const ProgressBar = ({ percentile }) => {
    return (React.createElement(Container, { progress: percentile },
        React.createElement("div", { className: "bar" }),
        React.createElement("div", { className: "text" }, `${percentile}%`)));
};
export { ProgressBar };
//# sourceMappingURL=index.js.map